export default {
    pages: {
        214: [
            {
                /* A text_node was blocking 2 graphic_answer_nodes close to it from being interacted with.
                 * Decreasing the size of the text_node fixes this z-index issue
                 */
                id: '279776', // text_node.
                attributes: [
                    {
                        name: 'height',
                        value: '50'
                    },
                    {
                        name: 'width',
                        value: '50'
                    },
                ]
            },
        ],
        'Test Review': [ // Luckily, there's only one "Test Review" in book.xml so the key is unique.
            {
                id: '960091', // text_node.
                attributes: [
                    {
                        name: 'height',
                        value: '330' // Prevent the text from overlapping outside of its box and blocking a link.
                    }
                ]
            },
            {
                id: '960099', // text_node.
                attributes: [
                    {
                        name: 'height',
                        value: '330' // Prevent the text from overlapping outside of its box and blocking a link.
                    }
                ]
            },
            {
                id: '960107', // text_node.
                attributes: [
                    {
                        name: 'height',
                        value: '330' // Prevent the text from overlapping outside of its box and blocking a link.
                    }
                ]
            }
        ]
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.LLAS.3.1.1.js